export default __webpack_public_path__ + "images/7P.45d3bb4.png";